// extracted by mini-css-extract-plugin
module.exports = {"button":"profile-button_button__pmFCU","svg":"profile-button_svg__RuUW0","label":"profile-button_label__5Mbpt"};